import guid from '../util/guid';
import { inArray } from '../util/jquery';

export class Task {
    constructor(option) {
        this.context = option.context;
        this.id = option.id;
        this.params = option.params || [];
        this.execute = option.execute;
        this.executeIndex = 0;
        this.executionInterval = option.executionInterval;
    }
    addParameters(params) {
        const newParams = params.filter(instrument => {
            return inArray(this.params, instrument) < 0;
        });
        this.executeIndex = this.params.length;
        this.params.push(...newParams);
        return this;
    }
    deleteParameters(params) {
        this.params = this.params.filter(instrument => {
            return inArray(params, instrument) < 0;
        });
        this.executeIndex = this.params.length;
        return this;
    }
}

export class TaskManager {
    constructor() {
        this.id = guid();
        this.tasks = new Map();
        this.taskIntervals = new Map();
    }
    add(task) {
        if (task instanceof Task) {
            task.execute(task);
            if (!this.tasks.has(task.id)) {
                this.tasks.set(task.id, task);
                this.taskIntervals.set(
                    task.id,
                    setInterval(() => {
                        task.executeIndex = 0;
                        task.execute(task);
                    }, task.executionInterval)
                );
            }
        }
        return this;
    }
    remove(task) {
        const id = task instanceof Task ? task.id : task;
        if (this.tasks.has(id)) {
            const intervalId = this.taskIntervals.get(id);
            clearInterval(intervalId);
            this.taskIntervals.delete(id);
            this.tasks.delete(id);
        }
        return this;
    }
}
